import React from 'react';
import PropTypes from 'prop-types';
import HeaderLinks from './HeaderLinks';
import HeaderMain from './HeaderMain';
import { AppBar } from '@material-ui/core';
import { useHeaderStyles } from './styles';
import { useLocation } from 'react-router-dom';
import { HOME_ROUTE } from '../../../constants/routes';
import BackButton from '../../common/BackButton/';

const Header = ({ ...props }) => {
  const { mobile } = props;
  const classes = useHeaderStyles();
  const location = useLocation();
  return (
    <React.Fragment>
      <AppBar elevation={0} className={classes.mainRoot} position="static">
        {!mobile && <HeaderLinks />}
        <HeaderMain mobile={mobile} />
        {mobile && location.pathname !== HOME_ROUTE && <BackButton />}
      </AppBar>
    </React.Fragment>
  );
};

Header.propTypes = {
  mobile: PropTypes.bool,
};

export default Header;
